import React from "react";
import QRCode from "react-qr-code";
import CustomModalV1 from "components/custom-modal/CustomModalV1";
import ButtonV1 from "components/button/Button";
import { XIconV1 } from "images/image-component";
import "./qr-modal.css";

interface Props {
  isOpen: boolean;
  data: string;
  close: () => void;
  /** Required — only the caller knows which token is selected. */
  warning: React.ReactNode;
}

function QrModal({ isOpen, data, close, warning }: Props) {
  return (
    <CustomModalV1 isOpen={isOpen} handleClose={close}>
      <button className="v1-modal-close" onClick={close} aria-label="Close">
        <XIconV1 />
      </button>

      <div className="v1-qr-modal">
        <h3 className="v1-qr-title">Scan QR Code</h3>

        {warning && <div className="v1-qr-warn">{warning}</div>}

        <div className="v1-qr-code-wrap">
          <QRCode
            size={180}
            value={data}
            viewBox="0 0 256 256"
            style={{ display: "block" }}
          />
        </div>

        <ButtonV1 variant="subtle" onClick={close} className="v1-auth-submit">
          Close
        </ButtonV1>
      </div>
    </CustomModalV1>
  );
}

export default QrModal;
